import { Input, Select } from "antd"
import React, { useRef } from "react"
import CustomRangePicker from "src/components/CustomRangePickerMobile/CustomRangePicker"
import SelectCarrier from "src/components/Dropdown/SelectCarrier"
import SelectLocalRoaming from "src/components/Dropdown/SelectLocalRoaming"
import SelectSimType from "src/components/Dropdown/SelectSimType"
import Button from "src/components/MyButton/Button"
import SvgIcon from "src/components/SvgIcon"
// import { InputSearchStyle } from "../../Setting/common/styled";
const FilterPackage = ({ setFilter }) => {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 12,
        maxWidth: "1000px",
      }}
    >
      <SelectCarrier
        style={{ width: 150 }}
        onChange={val =>
          setFilter(prev => ({ ...prev, network_carrier_id: val }))
        }
      />
      <SelectLocalRoaming
        title="Local/Roaming"
        allowClear
        style={{ width: 150 }}
        onChange={val => setFilter(prev => ({ ...prev, service_type: val }))}
      />
      <SelectSimType
        title="Loại hình SIM"
        allowClear
        style={{ width: 150 }}
        onChange={val => setFilter(prev => ({ ...prev, sim_type: val }))}
      />
    </div>
  )
}
export default FilterPackage
